export const CUSTOMER_MANAGER_TA_CONTACT_UPDATE = 'customer_manager_ta_contact-update';
export const CUSTOMER_MANAGER_TA_PRODUCT_SWAP = 'customer_manager_ta_product-swap';
export const CUSTOMER_MANAGER_TA_ORDER_MANAGEMENT = 'customer_manager_ta_order_management'

export const hasRole = (role) => {
    let session = localStorage.getItem('session');
    let decodedSession = session ? JSON.parse(session) : session;
    if (!decodedSession) {
        return false;
    }
    const userRoles = decodedSession.user["cognito:groups"] || [];
    return userRoles.some(userRole => userRole === role);
};